import { useQuery } from '@tanstack/react-query'
import { statutoryApi } from '@/api'

/**
 * Query keys for statutory-related queries
 */
export const statutoryKeys = {
  all: ['statutory'] as const,
  upcoming: (days: number) => [...statutoryKeys.all, 'upcoming', days] as const,
}

/**
 * Hook to fetch upcoming statutory deadlines
 */
export function useUpcomingDeadlines(days: number = 30) {
  return useQuery({
    queryKey: statutoryKeys.upcoming(days),
    queryFn: () => statutoryApi.upcoming(days),
    // Refresh every 5 minutes since deadlines don't change frequently
    staleTime: 5 * 60 * 1000,
  })
}

/**
 * Hook to fetch next 7 days of statutory deadlines (for dashboard)
 */
export function useWeekDeadlines() {
  return useUpcomingDeadlines(7)
}

/**
 * Hook to fetch next 30 days of statutory deadlines (for calendar)
 */
export function useMonthDeadlines() {
  return useUpcomingDeadlines(30)
}
